// @ts-ignore - React import for JSX compatibility
import React from 'react';
import {
  Button as MuiButton,
  type ButtonProps as MuiButtonProps,
} from '@mui/material';
import styled from 'styled-components';

const StyledButton = styled(MuiButton)<{ $isOutlined?: boolean }>`
  line-height: 16px;

  ${({ $isOutlined }) =>
    $isOutlined &&
    `
    color: #fff;
    border: solid 1px #fff;
  `}

  @media (max-width: 600px) {
    font-size: 11px;
    line-height: 11px;
  }
`;

interface BasicButtonProps extends Omit<MuiButtonProps, 'variant'> {
  variant?: 'outlined' | 'contained' | 'text';
  text: string;
  icon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function BasicButton({
  variant = 'contained',
  text,
  icon,
  onClick,
  ...props
}: BasicButtonProps) {
  return (
    <StyledButton
      $isOutlined={variant === 'outlined'}
      variant={variant}
      startIcon={icon}
      onClick={onClick}
      {...props}
    >
      {text}
    </StyledButton>
  );
}
